import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IUiState } from './state'
import { ErrorMessage } from '@/models/alo/ErrorMessage'
import { ExportCatalogType } from '@/enum/ExportCatalogType'

const mutations: MutationTree<IUiState> = {
    [types.UI_CLOSE_SNACKBAR]: (state) => {
        state.snackMessages = []
    },
    [types.UI_ADD_SNACK_MESSAGE]: (state,message:string) => {
        state.snackMessages.splice(0,0,message)
    },
    [types.UI_SET_CONTENT_HEIGHT]: (state,height:number) => {
        state.contentHeight = height
    },    
    [types.UI_CLOSE_ERROR]: (state) => {
        state.errorMessages = []
    },    
    [types.UI_ERROR_MESSAGE]: (state,error:ErrorMessage) => {
        state.errorMessages.splice(0,0,error)
    },
    [types.UI_SET_SEARCH_FLUX]: (state,search:string) => {
        state.searchFlux = search
    },
    [types.UI_SET_SORT_FLUX_DESC]: (state,desc:boolean) => {
        state.sortFluxDesc = desc
    },
    [types.UI_SET_SORT_FLUX_BY]: (state,sort:string) => {
        state.sortFluxBy = sort
    },
    [types.UI_SET_SEARCH_PARTENAIRE]: (state,search:string) => {
        state.searchPartenaire = search
    },    
    [types.UI_SET_SORT_PARTENAIRE_DESC]: (state,desc:boolean) => {
        state.sortPartenaireDesc = desc
    },
    [types.UI_SET_SORT_PARTENAIRE_BY]: (state,sort:string) => {
        state.sortPartenaireBy = sort
    },
    [types.UI_SET_SEARCH_DATASOURCE]: (state,search:string) => {
        state.searchDataSource = search
    },    
    [types.UI_SET_SORT_DATASOURCE_DESC]: (state,desc:boolean) => {
        state.sortDataSourceDesc = desc
    },
    [types.UI_SET_SORT_DATASOURCE_BY]: (state,sort:string) => {
        state.sortDataSourceBy = sort
    },
    [types.UI_SET_SEARCH_FEEDDOWNLOAD]: (state,search:string) => {
        state.searchFeedDownload = search
    },    
    [types.UI_SET_SORT_FEEDDOWNLOAD_DESC]: (state,desc:boolean) => {
        state.sortFeedDownloadDesc = desc
    },
    [types.UI_SET_SORT_FEEDDOWNLOAD_BY]: (state,sort:string) => {
        state.sortFeedDownloadBy = sort
    },
    [types.UI_SET_SEARCH_FLUXBUILDER]: (state,search:string) => {
        state.searchFluxBuilder = search
    },    
    [types.UI_SET_SORT_FLUXBUILDER_DESC]: (state,desc:boolean) => {
        state.sortFluxBuilderDesc = desc
    },
    [types.UI_SET_SORT_FLUXBUILDER_BY]: (state,sort:string) => {
        state.sortFluxBuilderBy = sort
    },
    [types.UI_SET_SEARCH_META]: (state,search:string) => {
        state.searchMeta = search
    },    
    [types.UI_SET_SORT_META_DESC]: (state,desc:boolean) => {
        state.sortMetaDesc = desc
    },
    [types.UI_SET_SORT_META_BY]: (state,sort:string) => {
        state.sortMetaBy = sort
    },
    
    //////////////////////////////////////////////////////////////////
    // PERSONNE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_PERSONNE]: (state,search:string) => {
        state.searchPersonne = search
    },    
    [types.UI_SET_SORT_PERSONNE_DESC]: (state,desc:boolean) => {
        state.sortPersonneDesc = desc
    },
    [types.UI_SET_SORT_PERSONNE_BY]: (state,sort:string) => {
        state.sortPersonneBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // PROFIL_EXCLUSION
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_PROFIL_EXCLUSION]: (state,search:string) => {
        state.searchProfilExclusion = search
    },    
    [types.UI_SET_SORT_PROFIL_EXCLUSION_DESC]: (state,desc:boolean) => {
        state.sortProfilExclusionDesc = desc
    },
    [types.UI_SET_SORT_PROFIL_EXCLUSION_BY]: (state,sort:string) => {
        state.sortProfilExclusionBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // GROUP_CARAC
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_GROUP_CARAC]: (state,search:string) => {
        state.searchGroupCarac = search
    },    
    [types.UI_SET_SORT_GROUP_CARAC_DESC]: (state,desc:boolean) => {
        state.sortGroupCaracDesc = desc
    },
    [types.UI_SET_SORT_GROUP_CARAC_BY]: (state,sort:string) => {
        state.sortGroupCaracBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // FILTER_META
    /////////////////////////////////////////////////////////////////    
    [types.UI_SET_FILTER_GROUPID]: (state,filter:number) => {
        state.filterGrouId = filter
    },
    [types.UI_SET_FILTER_DBNAME]: (state,filter:string) => {
        state.filterDbName = filter
    },
    [types.UI_SET_FILTER_DBKEY]: (state,filter:string) => {
        state.filterDbKey = filter
    },
    [types.UI_SET_FILTER_TYPE]: (state,filter:ExportCatalogType) => {
        state.filterType = filter
    },
}

export default mutations